import * as constants from "./constants";

export interface UserProfile {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    phone?: string;
    address?: string;
    is_active: boolean;
    role: Array<{ id: number; name: string }>;
    created_at?: string;
    updated_at?: string;
}

export interface AuthState {
    isLoading: boolean;
    errors: any;
    isAuthenticated: boolean;
    user: UserProfile | null;
    access_token: string | null;
    refresh_token: string | null;
    isUpdating: boolean;
}

export const initialState: AuthState = {
    isLoading: false,
    errors: null,
    isAuthenticated: false,
    user: null,
    access_token: null,
    refresh_token: null,
    isUpdating: false,
}

const authReducer = (state = initialState, action: any): AuthState => {
    switch (action.type) {

        case constants.LOGIN_REQUESTING:
            return {
                ...state,
                isLoading: true,
                errors: null,
            };

        case constants.LOGIN_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                isLoading: false,
                user: action.payload?.user,
                access_token: action.payload?.access,
                refresh_token: action.payload?.refresh,
                errors: null,
            };

        case constants.LOGIN_FAILED:
            return {
                ...state,
                isLoading: false,
                isAuthenticated: false,
                errors: action.error,
                user: null,
                access_token: null,
                refresh_token: null,
            };

        case constants.TOKEN_REFRESH_SUCCESS:
            return {
                ...state,
                access_token: action.access,
            };

        case constants.FETCH_PROFILE_SUCCESS:
            return {
                ...state,
                user: action.payload,
            };

        case constants.FETCH_PROFILE_FAILED:
            return state;

        // Update profile
        case constants.UPDATE_PROFILE_REQUESTING:
        case constants.CHANGE_PASSWORD_REQUESTING:
            return { ...state, isUpdating: true };
        case constants.UPDATE_PROFILE_SUCCESS:
            return { ...state, isUpdating: false, user: action.payload };
        case constants.CHANGE_PASSWORD_SUCCESS:
            return { ...state, isUpdating: false };
        case constants.UPDATE_PROFILE_FAILED:
        case constants.CHANGE_PASSWORD_FAILED:
            return { ...state, isUpdating: false };

        case constants.LOGOUT:
            return initialState;

        default:
            return state;
    }
}

export default authReducer;
